import React from 'react';

import { Box, VStack, Grid, GridItem } from '@chakra-ui/react';

import RateLimitCard from './components/RateLimitCard';
import TimezoneCard from './components/TimezoneCard';

const Dashboard = () => {
  return (
    <Box p={6} mt="50px">
      <VStack spacing={6} align="stretch">
        <Grid templateColumns={{ base: '1fr', lg: '1fr 1fr' }} gap={6}>
          <GridItem>
            <RateLimitCard />
          </GridItem>
          <GridItem>
            <TimezoneCard />
          </GridItem>
        </Grid>
      </VStack>
    </Box>
  );
};

export default Dashboard;
